<template>
  <PageWrapper
    :isLoading="isLoading"
    hasFilters
    @submitFilters="getAllResources"
  >
    <template #title> منابع زبان ها </template>
    <template #titleBtn>
      <BButton variant="success" @click="redirectToCreateResourcePage">
        ایجاد منبع جدید
      </BButton>
    </template>
    <template #filters>
      <LanguagePicker
        class="w-24 filters-width"
        @getLanguage="setLanguageId"
      ></LanguagePicker>
    </template>
    <CustomTable
      ref="resourceListTable"
      v-if="resourceList"
      :pageNumber="resourceListFilters.pageNumber"
      :count="resourceListFilters.count"
      :totalCount="totalCount"
      :tableColumns="tableColumns"
      :tableItems="resourceList"
      @changePage="changePage"
    >
      <template #actions="data">
        <BButton
          variant="success"
          size="sm"
          @click="renderRowDetails(data.index)"
        >
          مشاهده جزئیات
        </BButton>
      </template>

      <template #cellDetails="data">
        <ResourceListDetailsSection
          :resourceDetails="data.item.resourceDetails"
          :resourceId="data.item.id"
          @refetch="getAllResources"
        ></ResourceListDetailsSection>
      </template>
    </CustomTable>
  </PageWrapper>
</template>

<script>
export default {
  mounted() {
    this.getAllResources();
  },
  data() {
    return {
      isLoading: false,
      resourceList: null,
      totalCount: null,
      resourceListFilters: {
        pageNumber: 1,
        count: 10,
        languageId: null,
      },
      tableColumns: [
        {
          key: "id",
          label: "شناسه",
        },
        {
          key: "title",
          label: "نام زبان",
        },
        {
          key: "actions",
          label: "عملیات",
        },
      ],
    };
  },
  methods: {
    setLanguageId(languageId) {
      this.resourceListFilters.languageId = languageId;
    },
    renderRowDetails(rowIndex) {
      if (this.$refs.resourceListTable) {
        this.$refs.resourceListTable.showRowDetails(rowIndex);
      }
    },
    redirectToCreateResourcePage() {
      this.$router.push("/apps/resources/create");
    },
    changePage(pageNumber) {
      this.resourceListFilters.pageNumber = pageNumber;
      this.getAllResources();
    },

    async getAllResources() {
      try {
        this.isLoading = true;
        let _this = this;
        let getAllResources = new GetAllResources(_this);
        getAllResources.setRequestParam(_this.resourceListFilters);
        await getAllResources.fetch((res) => {
          _this.resourceList = res.data.data;
          _this.totalCount = res.data.totalCount;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },

  components: {
    LanguagePicker,
    PageWrapper,
    CustomTable,
    ResourceListDetailsSection,
    BButton,
  },
};
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import LanguagePicker from "@/views/components/Language/LanguagePicker.vue";
import ResourceListDetailsSection from "@/views/components/Resources/ResourceListDetailsSection.vue";

import { GetAllResources } from "@/libs/Api/Resources";
import { BButton } from "bootstrap-vue";
</script>
